/**
 * Listing preview: single image with prev/next and counter.
 */
import React from 'react';
import { Button } from 'react-bootstrap';

/**
 * @param {{
 *   pictures: Array<{ source: string }>,
 *   currentIndex: number,
 *   onPrevious: () => void,
 *   onNext: () => void
 * }} props
 */
const ListingPictureCarousel = ({ pictures, currentIndex, onPrevious, onNext }) => {
  if (!pictures?.length) return null;
  const safeIndex = Math.min(currentIndex, pictures.length - 1);
  return (
    <div className="listing-preview-pictures px-3 pt-3">
      <div className="listing-preview-picture-wrap">
        <img
          src={pictures[safeIndex]?.source}
          alt={`Product ${safeIndex + 1} of ${pictures.length}`}
          className="listing-preview-picture-img"
        />
      </div>
      <div className="d-flex align-items-center justify-content-center gap-2 mt-2 mb-3">
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={onPrevious}
          aria-label="Previous picture"
        >
          ← Previous
        </Button>
        <span className="small text-muted">
          {safeIndex + 1} / {pictures.length}
        </span>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={onNext}
          aria-label="Next picture"
        >
          Next →
        </Button>
      </div>
    </div>
  );
};

export default ListingPictureCarousel;
